import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-header"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  class: "dialog-body"
};
const _hoisted_4 = {
  class: "dialog-image"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "pdf-sender dialog-font"
};
const _hoisted_7 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.dialogVisible = $event),
    style: {
      maxWidth: '900px'
    },
    width: $data.dialog_width,
    "align-center": "",
    "append-to-body": "",
    ref: "dialog"
  }, {
    header: _withCtx(({
      close,
      titleId,
      titleClass
    }) => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h4", {
      id: titleId,
      class: _normalizeClass([titleClass, "dialog-head-titlefont"])
    }, _toDisplayString(_ctx.$t('messages.pdf_dialog_tile')), 11, _hoisted_2)])]),
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = $event => $data.dialogVisible = false),
      class: "dialog-font large-button"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('messages.general_cancel')), 1)]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.onConfirm,
      loading: $data.isSending,
      class: "dialog-font large-button"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('messages.general_confirm')), 1)]),
      _: 1
    }, 8, ["onClick", "loading"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
      src: $props.pdfimage
    }, null, 8, _hoisted_5)]), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('messages.pdf_sender')), 1), _createVNode(_component_el_input, {
      ref: "inputField",
      modelValue: $data.input,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.input = $event),
      type: "textarea",
      class: "dialog-input fixed-height-input",
      rows: "3",
      resize: "none",
      placeholder: $data.input_dict,
      clearable: ""
    }, null, 8, ["modelValue", "placeholder"])])]),
    _: 1
  }, 8, ["modelValue", "width"]);
}